module.exports = __webpack_public_path__ + "img/imgslider3.c55bc664.png";